export default __webpack_public_path__ + "static/media/imgTwo.21684895.png";